var swiper = new Swiper('.reviews-grid-card .rgc-swiper', {
    spaceBetween: 10,
    slidesPerView: 1.25,
    grabCursor: true,
    keyboard: true,
    navigation: {
        nextEl: '.reviews-grid-card .rgc-pagination .swiper-button-next',
        prevEl: '.reviews-grid-card .rgc-pagination .swiper-button-prev',
    },
    breakpoints: {
        769: {
            spaceBetween: 15,
            slidesPerView: 1.8
        },
        1024: {
            spaceBetween: 18,
            slidesPerView: 2
        },
        1280: {
            spaceBetween: 20,
            slidesPerView: 2.5
        },
        1600: {
            spaceBetween: 20,
            slidesPerView: 3
        }
    }
});